import { render, staticRenderFns } from "./Panoramica.vue?vue&type=template&id=79d510eb&scoped=true&"
import script from "./Panoramica.vue?vue&type=script&lang=js&"
export * from "./Panoramica.vue?vue&type=script&lang=js&"
import style0 from "./Panoramica.vue?vue&type=style&index=0&id=79d510eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d510eb",
  null
  
)

export default component.exports